import WorkerRoute from './WorkerRoute';

export default WorkerRoute;
